module.exports = __webpack_public_path__ + "fonts/ariblk.ec8b4d9c.ttf";